import styled from "styled-components";
import * as TypeStyle from "./Type";
import { IconWrapper } from "./IconWrapper";

const Disclaimer = styled.div`
    ${TypeStyle.Medium} {
        padding-left: 25px;
    }

    svg {
        position: absolute !important;
        top: 50%;
        left: 0;
        margin-top: 0;
        margin-left: 0;
        color: ${({ theme }) => theme.color.iconNeutral};
        transform: translateY(-50%) !important;
    }

    html[dir="rtl"] & {
        ${TypeStyle.Medium} {
            padding-left: 0;
            padding-right: 25px;
        }
    }
`;

export const Wrapper = styled.div`
    position: relative;
    ${IconWrapper} {
        position: absolute;
        top: 5px;
        right: 5px;
    }

    ${TypeStyle.Medium} {
        line-height: 2.4rem;
        white-space: normal;
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            left: 5px;
            right: 0;
        }
    }
`;

export default Disclaimer;
